<template>
  <div class="listNotation">
    <div class="screening">
      <el-popover
        placement="bottom-start"
        popper-class="popperStyle"
        width="150"
        trigger="click"
      >
        <el-checkbox-group size="medium" v-model="source" @change="sureSelect">
          <el-checkbox label="1">我的创建</el-checkbox>
          <!-- <el-checkbox label="2">我的修改</el-checkbox> -->
        </el-checkbox-group>
        <el-button slot="reference" class="screenSource" type="text"
          >数据来源<i class="el-icon-arrow-down"></i
        ></el-button>
      </el-popover>
      <el-button type="text" class="screenSource" @click="sortData"
        >排序<i :class="[sortUp ? 'el-icon-sort-up' : 'el-icon-sort-down']"></i
      ></el-button>
      <el-popover
        placement="bottom-start"
        popper-class="popperStyle"
        width="150"
        trigger="click"
      >
        <el-checkbox-group
          size="medium"
          v-model="queryForm.statusIdList"
          @change="sureSelect"
        >
          <el-checkbox
            v-for="item in dicList.statusList"
            :label="item.id"
            :key="item.id"
            >{{ item.cnName }}</el-checkbox
          >
        </el-checkbox-group>
        <el-button slot="reference" class="screenSource" type="text"
          >状态<i class="el-icon-arrow-down"></i
        ></el-button>
      </el-popover>
      <el-button type="text" class="screenSource" @click="moreSelect"
        >高级筛选<i
          :class="[selectBoolean ? 'el-icon-arrow-up' : 'el-icon-arrow-down']"
        ></i
      ></el-button>
      <img
        src="./images/dwxs.png"
        class="markShow"
        alt="显隐锚点"
        v-if="markBoolean"
        @click="changedwxs"
        title="点击隐藏全部"
      />
      <img
        src="./images/dwyc.png"
        class="markShow"
        alt="显隐锚点"
        v-else
        @click="changedwxs"
        title="点击显示全部"
      />
    </div>
    <div class="logo" v-if="type == 'rvt' && !selectBoolean">
      <span class="name">标签选择：</span>
      <span
        class="labelLogo"
        :class="{ active: labelIndexArray.includes(0) }"
        @click="choiceLabel(0)"
        >全部</span
      >
      <span
        class="labelLogo"
        :class="{ active: labelIndexArray.includes(1) }"
        @click="choiceLabel(1)"
        >2D</span
      >
      <span
        class="labelLogo"
        :class="{ active: labelIndexArray.includes(2) }"
        @click="choiceLabel(2)"
        >3D</span
      >
      <span
        class="labelLogo"
        :class="{ active: labelIndexArray.includes(3) }"
        @click="choiceLabel(3)"
        >整合模型</span
      >
    </div>
    <div class="search" v-if="!selectBoolean">
      <el-input
        v-model="keyword"
        size="small"
        placeholder="请输入问题描述"
        suffix-icon="el-icon-search"
        @input="sureSelect"
      >
      </el-input>
      <i class="el-icon-refresh-right" @click="update"></i>
      <img
        src="./images/daochu.png"
        alt="导出问题列表"
        @click="exportExcel"
        title="导出问题列表"
      />
    </div>
    <!-- 问题列表 -->
    <div
      class="list"
      v-if="!selectBoolean"
      v-loading="loading"
      element-loading-text="数据获取中"
    >
      <ul
        class="infinite-list"
        :infinite-scroll-immediate="false"
        :infinite-scroll-delay="500"
        v-infinite-scroll="load"
        style="overflow: auto"
      >
        <li
          v-for="item in nolist"
          class="infinite-list-item"
          :key="item.questionId"
          :class="{ active: activeIndex == item.questionId }"
          @click="openDetail(item)"
        >
          <div class="top" v-if="type == 'rvt'">
            <span
              class="labelLogo active"
              v-for="(item, index) in item.labelList"
              :key="index"
              >{{ item }}</span
            >
            <span class="right">
              <img
                src="./images/dingwei.png"
                alt="定位"
                @click.stop="aim(item)"
              />
              <img
                src="./images/shanchu.png"
                alt="删除"
                @click.stop="delannotation(item.questionId)"
              />
            </span>
          </div>
          <div class="up" v-if="type == 'rvt'">
            <!-- 处理问题 -->
            <!-- <el-popover
              placement="bottom"
              width="300"
              :key="item.questionId"
              trigger="manual"
              :ref="`popover${item.questionId}`"
            >
              <el-form
                :ref="`formstatus${item.questionId}`"
                :rules="statusRules"
                :model="formstatus"
                class="statusForm"
                size="mini"
                label-position="top"
              >
                <el-form-item label="问题状态:" prop="statusId">
                  <el-select
                    size="small"
                    v-model="formstatus.statusId"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="ele in dealList"
                      :key="ele.id"
                      :label="ele.cnName"
                      :value="ele.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="说明:">
                  <el-input
                    v-model="formstatus.content"
                    placeholder="请输入说明"
                    type="textarea"
                    maxlength="200"
                    show-word-limit
                  ></el-input>
                </el-form-item>
                <el-form-item class="footer">
                  <el-button size="mini" @click="closepop(item.questionId)"
                    >取 消</el-button
                  >
                  <el-button
                    size="mini"
                    type="primary"
                    @click="changeStatus(item)"
                    >确 定</el-button
                  >
                </el-form-item>
              </el-form>
              <span
                slot="reference"
                class="status"
                :class="{
                  status1: item.queStatus == '待修改',
                  status2: item.queStatus == '已修改',
                  status3: item.queStatus == '已复核',
                  status4: item.queStatus == '已取消',
                  status5: item.queStatus == '无效',
                }"
                @click.stop="dealStatus(item)"
                >【{{ item.queStatus }}】</span
              >
            </el-popover> -->

             <el-dropdown
              trigger="hover"
              :key="item.questionId"
              :ref="`popover${item.questionId}`"
              @command="commandStatus"
            >
              <span
                class="status"
                :class="{
                  status1: item.queStatus == '待修改',
                  status2: item.queStatus == '已修改',
                  status3: item.queStatus == '不修改',
                  status4: item.queStatus == '已销项',
                }"
                >【{{ item.queStatus }}】
              </span>
              <el-dropdown-menu slot="dropdown" v-if="item.dealList && item.dealList.length > 0">
                 <el-dropdown-item 
                  v-for="ele in item.dealList" 
                  :key="ele.id" 
                  :value="ele.id" 
                  :command="{row:item, queStatusId: ele.id, queStatus: ele.cnName}">
                  {{ ele.cnName }}
                 </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <span class="checkContent" :title="item.checkContent">
              {{ item.checkContent }}
            </span>
          </div>
          <div class="up" v-else>
            <!-- 处理问题 -->
            <el-dropdown
              trigger="hover"
              :key="item.questionId"
              :ref="`popover${item.questionId}`"
              @command="commandStatus"
            >
              <span
                class="status"
                :class="{
                  status1: item.queStatus == '待修改',
                  status2: item.queStatus == '已修改',
                  status3: item.queStatus == '不修改',
                  status4: item.queStatus == '已销项',
                }"
                >【{{ item.queStatus }}】
              </span>
              <el-dropdown-menu slot="dropdown" v-if="item.dealList && item.dealList.length > 0">
                 <el-dropdown-item 
                  v-for="ele in item.dealList" 
                  :key="ele.id" 
                  :value="ele.id" 
                  :command="{row:item, queStatusId: ele.id, queStatus: ele.cnName}">
                  {{ ele.cnName }}
                 </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

            <span class="checkContent" :title="item.checkContent">
              {{ item.checkContent }}
            </span>
            <span class="right">
              <img
                src="./images/dingwei.png"
                alt="定位"
                v-if="type == 'dwg' || type == 'pdf'"
                @click.stop="aim(item)"
              />
              <img
                src="./images/shanchu.png"
                alt="删除"
                @click.stop="delannotation(item.questionId)"
              />
            </span>
          </div>
          <div class="down">
            <span class="detailname">修改方:</span>
            <span :title="modifierNames(item)" class="modifierName">{{
              modifierNames(item)
            }}</span>
            <span class="detailname">创建时间:</span>
            <span>
              {{ createDatechange(item.createDate) }}
            </span>
          </div>
        </li>
      </ul>
    </div>
    <!-- 高级查询 -->
    <div class="select" v-else>
      <el-form
        ref="queryForm"
        :model="queryForm"
        label-position="top"
        label-width="86px"
        size="mini"
      >
        <el-form-item label="状态:">
          <el-checkbox-group v-model="queryForm.statusIdList">
            <el-checkbox
              v-for="(item, index) in dicList.statusList"
              :label="item.id"
              :key="index"
              >{{ item.cnName }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="意见类型:">
          <el-checkbox-group v-model="queryForm.qmTypeIdList">
            <el-checkbox
              v-for="(item, index) in dicList.checkTypeList"
              :label="item.id"
              :key="index"
              >{{ item.cnName }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="严重等级:">
          <el-checkbox-group v-model="queryForm.problemTypeIdList">
            <el-checkbox
              v-for="(item, index) in dicList.severityLevelList"
              :label="item.id"
              :key="index"
            >
              {{ item.cnName }}</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="创建人:" filterable>
          <el-select
            :popper-append-to-body="false"
            v-model="queryForm.createUserIdList"
            placeholder="请选择创建人"
            multiple
            filterable
          >
            <el-option
              v-for="(item, index) in dicList.createUserList"
              :key="index"
              :label="item.name"
              :value="item.userId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="处理方:" filterable>
          <el-select
            :popper-append-to-body="false"
            v-model="queryForm.modifierIdList"
            placeholder="请选择处理方"
            multiple
            filterable
          >
            <el-option
              v-for="(item, index) in dicList.modifierList"
              :key="index"
              :label="item.name"
              :value="item.userId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="专业:">
          <el-select
            v-model="queryForm.specIdList"
            multiple
            collapse-tags
            placeholder="请选择专业"
          >
            <el-option
              v-for="item in dicList.specList"
              :key="item.id"
              :label="item.cnName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建开始时间:">
          <el-date-picker
            ref="startDateRef"
            v-model="queryForm.startCreateTime"
            value-format="yyyy-MM-dd 00:00:00"
            type="date"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="创建结束时间:">
          <el-date-picker
            ref="endDateRef"
            v-model="queryForm.endCreateTime"
            value-format="yyyy-MM-dd 00:00:00"
            type="date"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="数据来源:">
          <el-select
            v-model="queryForm.sourceList"
            placeholder="请选择数据来源"
            multiple
          >
            <el-option
              v-for="(item, index) in dicList.problemSourceList"
              :key="index"
              :label="item.cnName"
              :value="item.cnName"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="footer">
        <el-button size="mini" @click="chongzhi">重置</el-button>
        <el-button
          size="mini"
          title="应用"
          type="primary"
          @click="moreSureSelect"
          >应用</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
const queryFormParams = () => ({
  statusIdList: [], //状态
  qmTypeIdList: [], //意见类型
  problemTypeIdList: [], //严重等级
  createUserIdList: [], //创建人
  modifierIdList: [], //处理人
  stageIdList: [], //阶段
  specIdList: [], //专业
  multiSpecList: [], //跨专业
  stageChildIdList: [], //子项
  startCreateTime: "", //创建开始时间
  endCreateTime: "", //创建结束时间
  sourceList: [], //数据来源
});
import notationService from "@/CommonDP/service/file-service";
import question from "@/xgzdService/question-service";
import { mapState } from "vuex";
export default {
  props: ["type"],
  data() {
    return {
      prjID: "",
      fileId: "",
      source: [], //来源
      statusList: [], //状态
      keyword: "", //问题描述
      dicList: {},
      sortUp: false, //排序
      markBoolean: true, //标记显隐
      selectBoolean: false, //高级筛选
      labelIndexArray: [0],
      queryForm: queryFormParams(),
      dealList: [],
      formstatus: {
        //修改问题状态
        statusId: "", //问题id
        content: "",
      },
      visible: false,
      statusRules: {
        statusId: [
          { required: true, message: "问题状态不可为空", trigger: "change" },
        ],
      },
      pageNum: 1,
      pageSize: 20,
      totalPage: 1, //总页数
      pageData: [], //一页的数据
      nolist: [], //查看总数
      loading: false,
      dataRow: "",
      activeIndex: "",
      mongeData: [],
      fileIdList: [],
      questionData: "",
    };
  },
  computed: {
    ...mapState({
      dwgdata: (state) => state.monge.dwgdata,
      spaceOfDwgData: (state) => state.monge.spaceOfDwgData,
      currentUserID: (state) => state.user.userId,
      modeldata: (state) => state.monge.modeldata,
      modelPageFileName: (state) => state.monge.modelPageFileName,
      hasDwg: (state) => state.monge.hasDwg,
    }),
    queryParams() {
      let labelList = [];
      for (let ele of this.labelIndexArray) {
        if (ele == 1) {
          labelList.push("2D");
        } else if (ele == 2) {
          labelList.push("3D");
        } else if (ele == 3) {
          labelList.push("整合模型");
        }
      }
      let fileIdList = [];
      if (this.type == "rvt" && !!this.modeldata.fileObj) {
        fileIdList = this.fileIdList;
      }
      const params = {
        ...this.queryForm,
        keyword: this.keyword,
        sortType: this.sortUp ? 0 : 1, //排序 排序方式 0升序 1降序
        currentUserScreenList: this.source,
        prjId: this.prjID,
        fileId: this.fileId,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        labelList,
        fileIdList,
      };
      return params;
    },

    statusParams() {
      const { questionId, queStatusId, queStatus, toStatusId, toStatusName } = this.dataRow,
        params = {
          content: '',
          prjId: this.prjID,
          idList: [questionId],
          statusId: queStatusId,
          statusName: queStatus,
          toStatusId: toStatusId,
          toStatusName: toStatusName,
        };
      return params;
    },
  },
  methods: {
    init(data) {
      this.questionData = data || "";
      if (this.type == "dwg") {
        this.prjID = JSON.parse(this.dwgdata).prjID;
        this.fileId = JSON.parse(this.dwgdata).fileId;
      } else if (this.type == "rvt") {
        if (!!this.modeldata.fileObj) {
          this.fileId = "";
          this.fileIdList = [];
          for (let item of this.modeldata.fileObj) {
            this.fileIdList.push(item.folderID);
          }
          this.prjID = this.modeldata.prjId;
        } else {
          this.fileId = this.modeldata.fileId;
          this.prjID = this.modeldata.prjId;
        }
      } else {
        this.fileId = this.$route.query.f;
        this.prjID = this.$route.query.prjId;
      }
      this.queryDic();
      this.pageNum = 1;
      this.mongeData = [];
      this.nolist = [];
      this.queryNotationList();
    },
    //查询时候的字典
    async queryDic() {
      const res = await question.getFilterDic(this.prjID);
      if (res.result === "0") {
        this.dicList = res.data || {};
      }
    },
    moreSureSelect() {
      this.selectBoolean = !this.selectBoolean;
      this.sureSelect();
    },
    sureSelect() {
      this.pageNum = 1;
      this.nolist = [];
      if (this.type == "dwg") {
        Monge.Map.Annotation.clear();
        Monge.Map.Annotation.deactive();
      } else if (this.type == "rvt") {
        Monge.Model.Mark.clear();
        if (this.hasDwg) {
          Monge.Map.Annotation.clear();
          Monge.Map.Annotation.deactive();
        }
      }
      this.queryNotationList();
    },
    //查询列表
    async queryNotationList() {
      this.pageData = [];
      this.loading = true;
      try {
        const res = await notationService.notationlist(this.queryParams);
        if (res.result == "0") {
          this.pageData = res.data;
          this.totalPage = res.totalPage;
          this.nolist = [...this.nolist, ...this.pageData];
          this.nolist.forEach(item => {
            item.dealList = this.dealStatus(item);
          })
          if (this.type == "dwg" || this.type == "rvt") {
            this.$store.dispatch(" ", this.nolist);
          }
          this.loading = false;
          await this.openAnnotation();
          if (!!this.questionData) {
            debugger;
            this.openDetail(this.questionData);
          }
        }
      } catch (error) {
        this.loading = false;
      }
    },
    //展示云线或者锚点
    openAnnotation() {
      if (this.type == "dwg") {
        this.$store.dispatch("setAnnotationData", "");
        //处理云线
        for (let element of this.pageData) {
          let color = "";
          switch (element.queStatus) {
            case "待修改":
              color = Number("0xEB5757");
              break;
            case "已修改":
              color = Number("0x27AE60");
              break;
            case "已复核":
              color = Number("0x4B6A8F");
              break;
            case "已取消":
              color = Number("0x8B8888");
              break;
            case "无效":
              color = Number("0xff0000");
              break;
          }
          const data =
            element.source === "WEB端" || element.source === "APP端"
              ? JSON.parse(element.coordinate)
              : JSON.parse(element.anchorPoint);
          if (!!data && element.layoutName == JSON.parse(this.spaceOfDwgData)) {
            data.stMarkNewInfo.color = color;
            Monge.Map.Annotation.add({
              id: element.questionId,
              data,
              callback: (type, data) => {
                let obj = { element, mongeId: data.id };
                this.mongeData.push(obj);
                this.$store.dispatch("setSpaceQmList", this.mongeData);
              },
            });
          }
        }
      } else if (this.type == "rvt") {
        this.$store.dispatch("setAnnotationData", "");
        for (let element of this.pageData) {
          if (element.flag23d == 1) {
            let color = "";
            switch (element.queStatus) {
              case "待修改":
                color = Number("0xEB5757");
                break;
              case "已修改":
                color = Number("0x27AE60");
                break;
              case "已复核":
                color = Number("0x4B6A8F");
                break;
              case "已取消":
                color = Number("0x8B8888");
                break;
              case "无效":
                color = Number("0xff0000");
                break;
            }
            let data = JSON.parse(element.coordinate);
            data.color = color;
            Monge.Model.Mark.add(data);
          } else {
            //模型图纸
            if (element.modelPageFileName == this.modelPageFileName) {
              let color = "";
              switch (element.queStatus) {
                case "待修改":
                  color = Number("0xEB5757");
                  break;
                case "已修改":
                  color = Number("0x27AE60");
                  break;
                case "已复核":
                  color = Number("0x4B6A8F");
                  break;
                case "已取消":
                  color = Number("0x8B8888");
                  break;
                case "无效":
                  color = Number("0xff0000");
                  break;
              }
              const data =
                element.source === "WEB端" || element.source === "APP端"
                  ? JSON.parse(element.coordinate)
                  : JSON.parse(element.anchorPoint);
              data.stMarkNewInfo.color = color;
              Monge.Map.Annotation.add({
                id: element.questionId,
                data,
                callback: (type, data) => {
                  let obj = { element, mongeId: data.id };
                  this.mongeData.push(obj);
                  this.$store.dispatch("setSpaceQmList", this.mongeData);
                },
              });
            }
          }
        }
      }
    },
    load() {
      if (this.totalPage > this.pageNum) {
        this.pageNum++;
        this.queryNotationList();
      }
    },
    //刷新
    update() {
      this.pageNum = 1;
      this.nolist = [];
      if (this.type == "dwg") {
        Monge.Map.Annotation.clear();
        Monge.Map.Annotation.deactive();
      } else if (this.type == "rvt") {
        Monge.Model.Mark.clear();
        if (this.hasDwg) {
          Monge.Map.Annotation.clear();
          Monge.Map.Annotation.deactive();
        }
      }
      this.queryNotationList();
    },
    //排序
    sortData() {
      this.sortUp = !this.sortUp;
      this.pageNum = 1;
      if (this.type == "dwg") {
        Monge.Map.Annotation.clear();
        Monge.Map.Annotation.deactive();
      } else if (this.type == "rvt") {
        Monge.Model.Mark.clear();
        if (this.hasDwg) {
          Monge.Map.Annotation.clear();
          Monge.Map.Annotation.deactive();
        }
      }
      this.nolist = [];
      this.queryNotationList();
    },
    //高级筛选
    moreSelect() {
      this.selectBoolean = !this.selectBoolean;
      console.log(this.selectBoolean);
    },
    //标记显隐
    async changedwxs() {
      this.markBoolean = !this.markBoolean;
      if (this.type == "dwg") {
        Monge.Map.Annotation.clear();
        Monge.Map.Annotation.deactive();
      } else if (this.type == "rvt") {
        Monge.Model.Mark.clear();
        if (this.hasDwg) {
          Monge.Map.Annotation.clear();
          Monge.Map.Annotation.deactive();
        }
      }
      if (this.markBoolean) {
        try {
          this.queryParams.pageNum = 0;
          this.queryParams.pageSize = 0;
          const res = await notationService.notationlist(this.queryParams);
          if (res.result == "0") {
            let mongeAllData = [];
            let list = res.data || [];
            this.$store.dispatch("setAnnotationList", list);
            if (this.type == "dwg") {
              for (let element of list) {
                let color = "";
                switch (element.queStatus) {
                  case "待修改":
                    color = Number("0xEB5757");
                    break;
                  case "已修改":
                    color = Number("0x27AE60");
                    break;
                  case "已复核":
                    color = Number("0x4B6A8F");
                    break;
                  case "已取消":
                    color = Number("0x8B8888");
                    break;
                  case "无效":
                    color = Number("0xff0000");
                    break;
                }
                let data =
                  element.source === "WEB端" || element.source === "APP端"
                    ? JSON.parse(element.coordinate)
                    : JSON.parse(element.anchorPoint);
                if (
                  !!data &&
                  element.layoutName == JSON.parse(this.spaceOfDwgData)
                ) {
                  data.stMarkNewInfo.color = color;
                  Monge.Map.Annotation.add({
                    data,
                    callback: (data) => {
                      let obj = { element, mongeId: data.id };
                      mongeAllData.push(obj);
                      this.$store.dispatch("setSpaceQmList", mongeAllData);
                    },
                  });
                }
              }
            } else if (this.type == "rvt") {
              this.$store.dispatch("setAnnotationData", "");
              for (let element of list) {
                if (element.flag23d == 1) {
                  let color = "";
                  switch (element.queStatus) {
                    case "待修改":
                      color = Number("0xEB5757");
                      break;
                    case "已修改":
                      color = Number("0x27AE60");
                      break;
                    case "已复核":
                      color = Number("0x4B6A8F");
                      break;
                    case "已取消":
                      color = Number("0x8B8888");
                      break;
                    case "无效":
                      color = Number("0xff0000");
                      break;
                  }
                  let data = JSON.parse(element.coordinate);
                  data.color = color;
                  Monge.Model.Mark.add(data);
                } else {
                  //模型图纸
                  if (element.modelPageFileName == this.modelPageFileName) {
                    let color = "";
                    switch (element.queStatus) {
                      case "待修改":
                        color = Number("0xEB5757");
                        break;
                      case "已修改":
                        color = Number("0x27AE60");
                        break;
                      case "已复核":
                        color = Number("0x4B6A8F");
                        break;
                      case "已取消":
                        color = Number("0x8B8888");
                        break;
                      case "无效":
                        color = Number("0xff0000");
                        break;
                    }
                    const data =
                      element.source === "WEB端" || element.source === "APP端"
                        ? JSON.parse(element.coordinate)
                        : JSON.parse(element.anchorPoint);
                    data.stMarkNewInfo.color = color;
                    Monge.Map.Annotation.add({
                      id: element.questionId,
                      data,
                      callback: (type, data) => {
                        let obj = { element, mongeId: data.id };
                        this.mongeData.push(obj);
                        this.$store.dispatch("setSpaceQmList", this.mongeData);
                      },
                    });
                  }
                }
              }
            }
          }
        } catch (error) {}
      }
    },
    //标签
    choiceLabel(index) {
      if (index === 0) {
        this.labelIndexArray = [0];
      } else {
        if (this.labelIndexArray.includes(index)) {
          this.labelIndexArray = this.labelIndexArray.filter(
            (ele) => ele !== index
          );
        } else {
          this.labelIndexArray = [...this.labelIndexArray, index].filter(
            (ele) => ele !== 0
          );
        }
      }
      this.pageNum = 1;
      if (this.type == "dwg") {
        Monge.Map.Annotation.clear();
        Monge.Map.Annotation.deactive();
      } else if (this.type == "rvt") {
        Monge.Model.Mark.clear();
        if (this.hasDwg) {
          Monge.Map.Annotation.clear();
          Monge.Map.Annotation.deactive();
        }
      }
      this.nolist = [];
      this.queryNotationList();
    },
    modifierNames(row) {
      let names = [];
      if (row.modifierList && row.modifierList.length > 0) {
        row.modifierList.forEach((ele) => {
          names.push(ele.modifierName);
        });
      }
      return names.join(",");
    },
    //导出问题列表
    exportExcel() {
      this.queryParams.pageNum = 0;
      this.queryParams.pageSize = 0;
      question.drawingDrawingQuesExport(this.queryParams).then((response) => {
        const fileName = "批注列表.xlsx";
        if ("msSaveOrOpenBlob" in navigator) {
          // 兼容ie
          // let blob = response
          window.navigator.msSaveOrOpenBlob(response, fileName);
          return;
        } else {
          const link = document.createElement("a");
          const blob = response;
          link.style.display = "none";
          link.href = URL.createObjectURL(blob);
          link.setAttribute("download", decodeURI(fileName));
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          this.excelDisable = true;
          this.excelSelect = false;
        }
      });
    },
    //打开详情
    async openDetail(item) {
      this.activeIndex = item.questionId;
      if (this.type == "rvt") {
        if (!this.hasDwg) {
          this.$store.dispatch("setAnnotationData", item);
          this.$emit("openDwg", item.modelPageFileName);
          await this.$nextTick();
          this.$emit("openDetail", item);
        } else if (
          this.hasDwg &&
          item.modelPageFileName !== this.modelPageFileName
        ) {
          this.$store.dispatch("setAnnotationData", item);
          this.$emit("openDwg", item.modelPageFileName);
          await this.$nextTick();
          this.$emit("openDetail", item);
        } else {
          this.$store.dispatch("setAnnotationData", item);
          this.$emit("openDwg", item.modelPageFileName);
          await this.$nextTick();
          this.$emit("openDetail", item);
        }
      } else {
        this.$emit("openDetail", item);
      }
    },
    //重置按钮
    chongzhi() {
      this.selectBoolean = !this.selectBoolean;
      this.queryForm = queryFormParams();
      this.pageNum = 1;
      if (this.type == "dwg") {
        Monge.Map.Annotation.clear();
        Monge.Map.Annotation.deactive();
      } else if (this.type == "rvt") {
        Monge.Model.Mark.clear();
        if (this.hasDwg) {
          Monge.Map.Annotation.clear();
          Monge.Map.Annotation.deactive();
        }
      }
      this.nolist = [];
      this.queryNotationList();
    },
    //修改单个问题状态
    dealStatus(item) {
      const { creatorId, queStatus, questionId, modifierList } = item;
      // this.$refs[`popover${questionId}`][0].showPopper = true;
      // this.dealList = this.dicList.statusList.filter(
      //   (ele) => ele.cnName !== queStatus
      // );
      return this.dicList.statusList.filter(
        (ele) => ele.cnName !== queStatus
      );
    },
    closepop(id) {
      this.$refs[`popover${id}`][0].showPopper = false;
    },
    //删除单个批注
    delannotation(id) {
      this.$confirm("是否删除当前批注?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let ids = [];
          ids.push(id);
          let res = await notationService.drawingQuestionDelete(ids);
          if (res.result === "0") {
            this.$message({ type: "success", message: "删除成功!" });
            this.pageNum = 1;
            this.nolist = [];
            if (this.type == "dwg") {
              Monge.Map.Annotation.clear();
              Monge.Map.Annotation.deactive();
            } else if (this.type == "rvt") {
              Monge.Model.Mark.clear();
              if (this.hasDwg) {
                Monge.Map.Annotation.clear();
                Monge.Map.Annotation.deactive();
              }
            }
            this.queryNotationList();
          }
        })
        .catch(() => {
          // this.$message({ type: "info", message: err.message || "无效" });
        });
    },
    async aim(item) {
      if (this.type == "dwg") {
        Monge.Map.Annotation.clear();
        Monge.Map.Annotation.deactive();
        if (item.layoutName !== JSON.parse(this.spaceOfDwgData)) {
          this.$store.dispatch("setAnnotationData", item);
          this.$store.dispatch(
            "setSpaceOfDwgData",
            JSON.stringify(item.layoutName)
          );
        } else {
          this.$store.dispatch("setAnnotationData", item);
          let color = "";
          switch (item.queStatus) {
            case "待修改":
              color = Number("0xEB5757");
              break;
            case "已修改":
              color = Number("0x27AE60");
              break;
            case "已复核":
              color = Number("0x4B6A8F");
              break;
            case "已取消":
              color = Number("0x8B8888");
              break;
            case "无效":
              color = Number("0xff0000");
              break;
          }
          const data =
            item.source === "WEB端" || item.source === "APP端"
              ? JSON.parse(item.coordinate)
              : JSON.parse(item.anchorPoint);
          if (!!data) {
            data.stMarkNewInfo.color = color;
            Monge.Map.Annotation.add({
              data,
              callback: (type, data) => {
                if (type === Monge.CallbackType.DONE) {
                  Monge.Map.Annotation.fitTo({ id: data.id });
                }
              },
            });
          }
        }
      } else if (this.type == "rvt") {
        if (item.flag23d == 1) {
          Monge.Model.Mark.clear();
          Monge.Model.Mark.deactive();
          let color = "";
          switch (item.queStatus) {
            case "待修改":
              color = Number("0xEB5757");
              break;
            case "已修改":
              color = Number("0x27AE60");
              break;
            case "已复核":
              color = Number("0x4B6A8F");
              break;
            case "已取消":
              color = Number("0x8B8888");
              break;
            case "无效":
              color = Number("0xff0000");
              break;
          }
          let data = JSON.parse(item.coordinate);
          data.color = color;
          Monge.Model.Mark.add(data);
          Monge.Model.Camera.setViewport(JSON.parse(item.viewPoint));
        } else {
          //模型图纸的定位
          if (item.modelPageFileName == this.modelPageFileName) {
            //打开图纸并且是当前图纸
            Monge.Map.Annotation.clear();
            Monge.Map.Annotation.deactive();
            let color = "";
            switch (item.queStatus) {
              case "待修改":
                color = Number("0xEB5757");
                break;
              case "已修改":
                color = Number("0x27AE60");
                break;
              case "已复核":
                color = Number("0x4B6A8F");
                break;
              case "已取消":
                color = Number("0x8B8888");
                break;
              case "无效":
                color = Number("0xff0000");
                break;
            }
            const data =
              item.source === "WEB端" || item.source === "APP端"
                ? JSON.parse(item.coordinate)
                : JSON.parse(item.anchorPoint);
            if (!!data) {
              data.stMarkNewInfo.color = color;
              Monge.Map.Annotation.add({
                data,
                callback: (type, data) => {
                  if (type === Monge.CallbackType.DONE) {
                    Monge.Map.Annotation.fitTo({ id: data.id });
                  }
                },
              });
            }
          } else {
            this.$store.dispatch("setAnnotationData", item);
            this.$emit("openDwg", item.modelPageFileName);
          }
        }
      } else if (this.type == "pdf") {
        this.$emit("fileaAim", item);
      }
    },
    async changeStatus(row) {
      this.dataRow = row;
      this.$refs[`formstatus${row.questionId}`][0].validate(async (valid) => {
        if (valid) {
          try {
            const res = await question.drawingannotationupdateStatus(
              this.statusParams
            );
            if (res.result == "0") {
              this.$message.success("修改成功");
              this.$refs[`popover${row.questionId}`][0].showPopper = false;
              this.formstatus.statusId = "";
              this.formstatus.content = "";
              this.nolist = [];
              this.queryNotationList();
              this.isRead = true;
            }
          } catch (error) {
            this.$refs[`popover${row.questionId}`][0].showPopper = false;
          }
        }
      });
    },
    async commandStatus({row,queStatusId, queStatus}) {
      this.dataRow = row;
      this.dataRow.toStatusId = queStatusId;
      this.dataRow.toStatusName = queStatus;
      const res = await question.drawingannotationupdateStatus(
              this.statusParams
      );
      if (res.result == "0") {
              this.$message.success("修改成功");
              this.formstatus.statusId = "";
              this.formstatus.content = "";
              this.nolist = [];
              this.queryNotationList();
              this.isRead = true;
      }
    },
    createDatechange(item) {
      let time = item.split(" ");
      return time[0];
    },
  },
};
</script>
<style lang="scss" scoped>
.listNotation {
  width: 100%;
  height: 100%;
  overflow: hidden;
  .labelLogo {
    border: 0.6px solid #7a87a5;
    box-sizing: border-box;
    color: #606266;
    cursor: pointer;
    border-radius: 18px;
    font-size: 14px;
    line-height: 20px;
    padding: 0 4px;
    margin-right: 5px;
  }
  .labelLogo:hover {
    border: 0.6px solid #3873fe;
  }
  .labelLogo.active {
    border: 0.6px solid #3873fe;
    color: #3873fe;
  }
  // overflow-y: auto;
  .screening {
    width: 100%;
    height: 30px;
    padding: 0 8px;
    display: flex;
    flex-direction: row;
    align-items: center;

    .screenSource {
      color: #606266;
      padding: 0 !important;
      margin-right: 8px;
      font-size: 14px;
      /deep/span {
        font-size: 14px;
      }
    }
    .markShow {
      cursor: pointer;
    }
  }
  .logo {
    width: 100%;
    height: 30px;
    padding: 0 8px;
    display: flex;
    flex-direction: row;
    align-items: center;
    .name {
      font-size: 14px;
      line-height: 30px;
      user-select: none;
      color: #606266;
    }
  }
  .search {
    width: 100%;
    height: 40px;
    padding: 0 8px;
    display: flex;
    flex-direction: row;
    align-items: center;
    i {
      font-size: 23px;
      color: #8692b0;
      margin-left: 4px;
      cursor: pointer;
    }
    img {
      margin-left: 4px;
      cursor: pointer;
    }
  }
  .list {
    border-top: 1px solid rgb(212, 217, 236);
    width: 100%;
    height: calc(100% - 90px);
    padding: 10px 0 10px 10px;
    .infinite-list {
      width: 100%;
      height: 100%;
      padding-right: 10px;
      .infinite-list-item {
        width: 100%;
        min-height: 76px;
        border-bottom: 1px solid rgb(212, 217, 236);
        border-radius: 4px;
        padding: 0 5px;
      }
      .active {
        background: #f3f6ff;
      }
      .infinite-list-item:hover {
        background: #f3f6ff;
      }
      .up {
        width: 100%;
        height: 38px;
        display: flex;
        flex-direction: row;
        align-items: center;
        .status {
          font-size: 14px;
          cursor: pointer;
        }
        .status1 {
          color: #eb5757;
        }
        .status2 {
          color:#eac100;
        }
        .status3 {
          color:#8b8888;
        }
        .status4 {
          color:#00b632;
        }
        .checkContent {
          font-size: 14px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          vertical-align: top;
          width: calc(100% - 120px);
          user-select: none;
        }
        .right {
          margin-left: auto;
          display: flex;
          flex-direction: row;
          img {
            margin-right: 5px;
            cursor: pointer;
          }
        }
      }
      .top {
        width: 100%;
        // height: 20px;
        padding-top: 10px;
        padding-left: 5px;
        display: flex;
        flex-direction: row;
        align-items: center;
        .right {
          margin-left: auto;
          display: flex;
          flex-direction: row;
          img {
            margin-right: 5px;
            cursor: pointer;
          }
        }
      }
      .down {
        width: 100%;
        height: 38px;
        display: flex;
        flex-direction: row;
        align-items: center;
        span {
          font-size: 14px;
          line-height: 18px;
        }
        .detailname {
          color: #606266;
          margin-right: 5px;
          user-select: none;
        }
        .modifierName {
          overflow: hidden;
          text-overflow: ellipsis;
          user-select: none;
          white-space: nowrap;
          width: calc(100% - 220px);
          vertical-align: top;
          margin-right: 10px;
        }
      }
    }
    // overflow-y: auto;
  }
  .select {
    border-top: 1px solid rgb(212, 217, 236);
    width: 100%;
    padding-left: 5px;
    height: calc(100% - 30px);
    .el-form {
      padding: 10px 5px 10px 0;
      width: 100%;
      height: calc(100% - 50px);
      overflow-y: auto;
    }
    .footer {
      width: 100%;
      height: 50px;
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      align-items: center;
      padding-right: 20px;
    }

    /deep/.el-checkbox {
      margin-right: 5px;
    }
    /deep/.el-select,
    .el-date-editor {
      width: 100%;
    }
    /deep/.el-form-item {
      margin-bottom: 10px;
    }
  }
}
// .popSource{
//    /deep/.el-checkbox{
//       padding: 8px 0;
//     }
// }
</style>